export default {
    getBasicYesNoForVueSelect(object) {
        return [
            { value: 'yes', title: 'Igen'},
            { value: 'no', title: 'Nem'},
        ]
    }
}